import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IExtensionGroup } from '../../../../extension-groups/models/extension-group.models';
import { ICheckoutExtensions } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

export interface ToggleExtensionGroupsDialogData {
  extension: ICheckoutExtensions;
  extensionGroups: IExtensionGroup[];
}

export interface ExtensionGroupSelection {
  groupId: number;
  componentId: number;
  groupName: string;
  selected: boolean;
}

export interface ToggleExtensionGroupsDialogResult {
  enabled: boolean;
  groupSelections: ExtensionGroupSelection[];
}

@Component({
  selector: 'toggle-extension-groups-dialog',
  templateUrl: './toggle-extension-groups-dialog.html',
  styleUrls: ['./toggle-extension-groups-dialog.scss'],
  standalone: false,
})
export class ToggleExtensionGroupsDialog implements OnInit {
  extensionName: string;
  enabled = true;
  groupSelections: ExtensionGroupSelection[] = [];

  constructor(
    public dialogRef: MatDialogRef<ToggleExtensionGroupsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ToggleExtensionGroupsDialogData,
  ) {}

  ngOnInit() {
    this.extensionName =
      this.data.extension.template?.internalName || this.data.extension.template?.title || 'Untitled';

    // Build list of groups that contain this extension
    this.groupSelections = [];
    this.data.extensionGroups.forEach((group) => {
      const component = group.groupComponents?.find((c) => c.extensionComponentId === this.data.extension.id);
      if (component) {
        this.groupSelections.push({
          groupId: group.id,
          componentId: component.id,
          groupName: group.name,
          selected: component.enabled,
        });
      }
    });
  }

  get selectedCount(): number {
    return this.groupSelections.filter((g) => g.selected).length;
  }

  get allSelected(): boolean {
    return this.groupSelections.length > 0 && this.groupSelections.every((g) => g.selected);
  }

  get isIndeterminate(): boolean {
    const selected = this.selectedCount;
    return selected > 0 && selected < this.groupSelections.length;
  }

  onSelectAll(checked: boolean) {
    this.groupSelections.forEach((group) => {
      group.selected = checked;
    });
  }

  onToggleGroup(index: number) {
    this.groupSelections[index].selected = !this.groupSelections[index].selected;
  }

  onToggleEnabled(value: boolean) {
    this.enabled = value;
    if (!value) {
      this.groupSelections.forEach((group) => {
        group.selected = false;
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const result: ToggleExtensionGroupsDialogResult = {
      enabled: this.enabled,
      groupSelections: this.groupSelections,
    };
    this.dialogRef.close(result);
  }
}
